import { Suggestion } from "./types";
import { USER_ID } from "./constants";

export function getDefinitions(obj: any, field: string): any[] {
  let definitions: string[] = [];

  if (Array.isArray(obj)) {
    for (let item of obj) {
      definitions.push(...getDefinitions(item, field));
    }
  } else if (typeof obj === "object" && obj !== null) {
    for (let prop in obj) {
      if (prop === field) {
        if (Array.isArray(obj[prop])) {
          definitions = [...definitions, ...obj[prop]];
        } else {
          definitions.push(obj[prop]);
        }
      } else {
        definitions.push(...getDefinitions(obj[prop], field));
      }
    }
  }

  return definitions;
}

export function getDetailDefinitions(obj: any, lang: string) {
  let result: any = {};

  obj?.forEach((res: any) => {
    res?.lexicalEntries?.forEach((lexicalEntry: any) => {
      const type = lexicalEntry?.lexicalCategory?.id as string;

      const definitions = getDefinitions(
        lexicalEntry?.entries,
        lang === "en" ? "definitions" : "translations"
      );
      if (type) {
        if (!result[type]) {
          result[type] = [];
        }
        result[type] = [
          ...result[type],
          ...definitions.map((o) => o?.text || o),
        ];
      }
    });
  });

  return result;
}

export const setUser = (id: string) => {
  localStorage.setItem(USER_ID, id);
};

export const getUser = () => {
  return localStorage.getItem(USER_ID) || "";
};

export const generateItemsPerPage = () => {
  const width = window.innerWidth;

  if (width <= 500) {
    return 3;
  }

  if (width <= 768) {
    return 4;
  }

  if (width <= 900) {
    return 5;
  }

  if (width <= 1280) {
    return 6;
  }

  return 8;
};

export const generateColor = (type: string) => {
  switch (type?.toLowerCase()) {
    case "verb":
      return "yellow";
    case "noun":
      return "green";
    case "adjective":
      return "blue";
    case "preposition":
      return "orange";
    case "adverb":
      return "red";
    default:
      return "purple";
  }
};

export const getFullType = (type: string) => {
  switch (type) {
    case "v":
      return "verb";
    case "n":
      return "noun";
    case "j":
      return "adjective";
    case "i":
      return "preposition";
    case "r":
      return "adverb";
    case "u":
      return "interjection";
    default:
      return type;
  }
};

export const generateSuggestion = (suggestion: Suggestion) => {
  if (!suggestion.pos) {
    return suggestion.word;
  }

  return `${suggestion.word} (${suggestion.pos})`;
};

export const generateSuggestionUrl = (suggestion: Suggestion) => {
  if (!suggestion.pos) {
    return `?keyword=${suggestion.word}`;
  }

  return `?keyword=${suggestion.word}&pos=${suggestion.pos}`;
};

export const generateSuggestionKey = (suggestion: Suggestion) => {
  return suggestion.word + "" + suggestion.pos;
};

export const formatSentence = (sentence: string, highlight: string): string => {
  let formattedSentence = sentence.trim(); // Remove leading and trailing whitespace
  if (formattedSentence.length > 0) {
    formattedSentence =
      formattedSentence.charAt(0).toUpperCase() + formattedSentence.slice(1); // Uppercase the first letter
    if (formattedSentence.charAt(formattedSentence.length - 1) !== ".") {
      // Check if the sentence ends with a period
      formattedSentence += "."; // If not, add a period
    }
  }
  const regex = new RegExp(`(${highlight})`, "gi"); // Create a RegExp with the highlight word, ignoring case
  const boldedString = formattedSentence.replace(regex, "<b>$1</b>"); // Replace the highlight word with the bolded version
  return "- " + boldedString;
};
